"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ContentCopy_1 = __importDefault(require("@mui/icons-material/ContentCopy"));
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const lodash_1 = __importDefault(require("lodash"));
const react_1 = require("react");
const companyQuery_1 = require("../../../../../queries/companyQuery");
const paymentQuery_1 = require("../../../../../queries/paymentQuery");
const userQuery_1 = require("../../../../../queries/userQuery");
const virtualCard_1 = require("../../../request/virtualCard");
const walletCard_1 = require("../../walletDetails/walletCard");
const CardDetails = ({ task }) => {
    const theme = (0, material_1.useTheme)();
    const taskId = task.request?.requestId || '';
    const { data: user } = (0, react_query_1.useQuery)(userQuery_1.userQuery);
    const { data: companyPropertiesData } = (0, react_query_1.useQuery)((0, companyQuery_1.companyPropertiesQuery)(user?.companyAccountId, { cardprovider: 'tsgo-cardprovider' }));
    const isAmexCardProvider = companyPropertiesData?.cardprovider === 'AMEX';
    const { data: card } = (0, react_query_1.useQuery)((0, paymentQuery_1.virtualCardQuery)({
        documentId: taskId,
        cardProvider: companyPropertiesData?.cardprovider,
    }));
    const virtualCard = (0, virtualCard_1.getVirtualCard)(card);
    const updatedCard = Object.assign({}, task.card, virtualCard);
    const newTaskUpdated = {
        ...task,
        card: updatedCard,
    };
    const [isHovering, setIsHovering] = (0, react_1.useState)(false);
    const [copyDetails, setCopyDetails] = (0, react_1.useState)({ isCopied: false, copySuccessMessage: '' });
    const cardNumber = (0, virtualCard_1.getCardNumber)(newTaskUpdated.card);
    const isCopyAllowed = !Number.isNaN(Number(cardNumber));
    const formattedExpirationDate = (0, virtualCard_1.getFormattedExpiration)(newTaskUpdated.card.expirationDate);
    const copyItems = {
        number: {
            name: 'card number',
            data: cardNumber,
        },
        cvc: {
            name: walletCard_1.cvv2OrCvc,
            data: (0, virtualCard_1.getCVVNumber)(newTaskUpdated.card, companyPropertiesData?.cardprovider || ''),
        },
    };
    const setCopyItem = (copyItemKey, event) => {
        event.stopPropagation();
        if (!copyItems[copyItemKey] || !isCopyAllowed) {
            return;
        }
        const copyItem = copyItems[copyItemKey];
        setIsHovering(true);
        setCopyDetails({
            isCopied: false,
            copySuccessMessage: 'Copied ' + copyItem.name + '!',
        });
    };
    async function onCopySuccess(copyItemKey, event) {
        event.stopPropagation();
        if (!copyItems[copyItemKey] || !isCopyAllowed) {
            return;
        }
        const copyItem = copyItems[copyItemKey];
        await navigator.clipboard.writeText(copyItem.data);
        setCopyDetails({
            isCopied: true,
            copySuccessMessage: 'Copied ' + copyItem.name + '!',
        });
    }
    return ((0, jsx_runtime_1.jsxs)(virtualCard_1.StyledCard, { "data-testid": "my-card-content", onClick: event => onCopySuccess('number', event), sx: [
            {
                cursor: isCopyAllowed && isHovering ? 'pointer' : 'default',
            },
            globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                ? {
                    height: '180px',
                    width: 'auto',
                }
                : {},
        ], children: [isAmexCardProvider ? (lodash_1.default.isEmpty(task.card) ? null : ((0, jsx_runtime_1.jsx)(virtualCard_1.StyledChip, { label: (0, virtualCard_1.getVirtualCardStatusAndLabel)({
                    card: newTaskUpdated.card,
                    fields: newTaskUpdated.context?.request.fields,
                }), color: (0, virtualCard_1.isActive)(newTaskUpdated?.card) ? 'success' : 'error' }))) : null, (0, jsx_runtime_1.jsx)(virtualCard_1.StyledHoverText, { children: isCopyAllowed && isHovering ? (copyDetails.isCopied ? copyDetails.copySuccessMessage : '') : '' }), (0, jsx_runtime_1.jsxs)(virtualCard_1.StyledGrid, { onMouseEnter: event => setCopyItem('number', event), onMouseOut: () => setIsHovering(false), className: isCopyAllowed ? 'isRevealDetailsAllowed' : '', children: [(0, virtualCard_1.formatCardNumber)(newTaskUpdated.card).map((cardNumberPiece, index) => ((0, jsx_runtime_1.jsx)(material_1.Typography, { sx: [
                            {
                                fontSize: '18px',
                            },
                            globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                ? {
                                    textShadow: '1px 1px hsl(204, 25%, 8%)',
                                    color: 'hsl(0, 0%, 100%)',
                                    marginRight: '-2.75px',
                                }
                                : {},
                        ], children: cardNumberPiece }, cardNumberPiece + index))), isCopyAllowed && ((0, jsx_runtime_1.jsx)(ContentCopy_1.default, { sx: {
                            fontSize: theme.typography.pxToRem(14),
                            color: 'hsl(0, 0%, 100%)',
                            marginLeft: theme.tsGoUnit.tsUnitQuarter,
                        } }))] }), (0, jsx_runtime_1.jsxs)(virtualCard_1.StyledBox, { style: {
                    ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                        ? {
                            paddingBottom: '30px',
                        }
                        : {}),
                }, children: [formattedExpirationDate ? ((0, jsx_runtime_1.jsxs)(virtualCard_1.StyledElement, { children: [walletCard_1.expirationLabel ? (0, jsx_runtime_1.jsx)(virtualCard_1.ExpirationLabel, { children: walletCard_1.expirationLabel }) : null, (0, jsx_runtime_1.jsx)(virtualCard_1.ExpirationValue, { "data-testid": "expirationDate", children: formattedExpirationDate })] })) : null, (0, jsx_runtime_1.jsxs)(virtualCard_1.StyledElement, { onMouseOver: event => setCopyItem('cvc', event), onMouseOut: () => setIsHovering(false), onClick: event => onCopySuccess('cvc', event), sx: { display: 'flex', justifyContent: 'flex-end' }, children: [(0, jsx_runtime_1.jsx)(virtualCard_1.ExpirationLabel, { children: walletCard_1.cvv2OrCvc }), (0, jsx_runtime_1.jsx)(virtualCard_1.ExpirationValue, { children: (0, virtualCard_1.getCVVNumber)(newTaskUpdated.card, companyPropertiesData?.cardprovider || '') }), isCopyAllowed && ((0, jsx_runtime_1.jsx)(ContentCopy_1.default, { sx: { fontSize: theme.typography.pxToRem(14), color: 'hsl(0, 0%, 100%)' } }))] })] })] }));
};
exports.default = CardDetails;
